import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../../Styles/Common.css";

const FAQManager = () => {
  const [faqData, setFaqData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [searchTerm, setSearchTerm] = useState(""); // Search filter state
  const [editFaq, setEditFaq] = useState({
    id: null,
    panelTitle: "",
    ques: "",
    ans: "",
  });
  const [newFaq, setNewFaq] = useState({
    panelTitle: "",
    ques: "",
    ans: "",
  });
  const [showPopup, setShowPopup] = useState(false);

  const API_URL = "https://iteyonikservicesinstitute.com/faq/";

  // Fetch FAQs
  const fetchFaqs = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(API_URL);
      setFaqData(response.data);
      setIsLoading(false);
    } catch (error) {
      toast.error("Failed to fetch FAQs.");
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchFaqs();
  }, []);

  // Handle Delete
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this FAQ?")) {
      try {
        await axios.delete(`${API_URL}${id}/`);
        toast.success("FAQ deleted successfully!");
        fetchFaqs();
      } catch (error) {
        toast.error("Failed to delete FAQ.");
      }
    }
  };

  // Handle Edit
  const handleEdit = (faq) => {
    setIsEditing(true);
    setEditFaq(faq);
    setShowPopup(true);
  };

  // Handle Update
  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${API_URL}${editFaq.id}/`, editFaq);
      toast.success("FAQ updated successfully!");
      fetchFaqs();
      setIsEditing(false);
      setShowPopup(false);
      setEditFaq({ id: null, panelTitle: "", ques: "", ans: "" });
    } catch (error) {
      toast.error("Failed to update FAQ.");
    }
  };

  // Handle Add New FAQ
  const handleAdd = async (e) => {
    e.preventDefault();
    try {
      await axios.post(API_URL, newFaq);
      toast.success("FAQ added successfully!");
      fetchFaqs();
      setShowPopup(false);
      setNewFaq({ panelTitle: "", ques: "", ans: "" });
    } catch (error) {
      toast.error("Failed to add FAQ.");
    }
  };

  // Filtered FAQs based on search term
  const filteredFaqs = faqData.filter((faq) =>
    faq.ques.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="container">
      <ToastContainer position="bottom-right" autoClose={3000} />
      <div className="header-container">
        <h2>FAQ Manager</h2>
        <button
          className="add-lead-btn"
          onClick={() => {
            setShowPopup(true);
            setIsEditing(false);
          }}
        >
          <i className="fa fa-plus"></i>
        </button>
      </div>

      {/* Search Filter */}
      <div className="feedback-filters">
        <input
          type="text"
          placeholder="Search by Question"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="filter-input"
        />
      </div>

      {/* FAQ Table */}
      {isLoading ? (
        <p>Loading FAQs...</p>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>#</th>
              <th>Panel Title</th>
              <th>Question</th>
              <th>Answer</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredFaqs.map((faq, index) => (
              <tr key={faq.id}>
                <td>{index + 1}</td>
                <td>{faq.panelTitle}</td>
                <td>{faq.ques}</td>
                <td>{faq.ans}</td>
                <td>
                  <i
                    onClick={() => handleEdit(faq)}
                    className="fa fa-edit action-icon editIcon"
                  ></i>
                  <i
                    onClick={() => handleDelete(faq.id)}
                    className="fa fa-trash action-icon deleteIcon"
                  ></i>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* Popup for Add/Edit */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <h3>{isEditing ? "Edit FAQ" : "Add New FAQ"}</h3>
            <form onSubmit={isEditing ? handleUpdate : handleAdd}>
              <div className="form-group">
                <label>Panel Title</label>
                <input
                  type="text"
                  value={isEditing ? editFaq.panelTitle : newFaq.panelTitle}
                  onChange={(e) =>
                    isEditing
                      ? setEditFaq({ ...editFaq, panelTitle: e.target.value })
                      : setNewFaq({ ...newFaq, panelTitle: e.target.value })
                  }
                  required
                />
              </div>
              <div className="form-group">
                <label>Question</label>
                <textarea
                  value={isEditing ? editFaq.ques : newFaq.ques}
                  onChange={(e) =>
                    isEditing
                      ? setEditFaq({ ...editFaq, ques: e.target.value })
                      : setNewFaq({ ...newFaq, ques: e.target.value })
                  }
                  required
                />
              </div>
              <div className="form-group">
                <label>Answer</label>
                <textarea
                  value={isEditing ? editFaq.ans : newFaq.ans}
                  onChange={(e) =>
                    isEditing
                      ? setEditFaq({ ...editFaq, ans: e.target.value })
                      : setNewFaq({ ...newFaq, ans: e.target.value })
                  }
                  required
                />
              </div>
              <div className="form-actions">
                <button type="submit">
                  {isEditing ? <i className="fa fa-edit"></i> : <i className="fa fa-plus-square"></i>}
                </button>
                <button
                  type="button"
                  onClick={() => setShowPopup(false)}
                  className="cancel-btn fa fa-close"
                ></button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default FAQManager;
